import React, { Fragment, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Select from 'react-select';
import { Tooltip } from '@mui/material';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { MonitorPause } from 'lucide-react';


const ItemCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    // Logout if token is expired
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, token, logout]);


    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        Code: '',
        BarCode: '',
        Name: '',
        SearchableName: '',
        CategoryId: '0',
        UnitofMeasureId: '0',
        SupplierId: '0',
        MRP: '0',
        SaleRate: '0',
        WholeSaleRate: '0',
        PurchaseRate: '0',
        ReOrderLevelQty: '0',
        CGSTRate: '0',
        SGSTRate: '0',
        HSNCode: '',
        OpeningStock: '0',
        CreatedBy: userId,
        CreatedDate: new Date().toISOString(),
    });

    // const handleChange = (event) => {
    //     const { name, value, type } = event.target;
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [name]: type === 'checkbox' ? !prevData[name] : value,
    //     }));
    // };
    const [gstError, setGstError] = useState('');
    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedFormData = { ...formData, [name]: value };

        setFormData(updatedFormData);

        // Validation: CGST and SGST must be equal
        if (
            name === 'CGSTRate' || name === 'SGSTRate'
        ) {
            if (
                updatedFormData.CGSTRate !== '' &&
                updatedFormData.SGSTRate !== '' &&
                parseFloat(updatedFormData.CGSTRate) !== parseFloat(updatedFormData.SGSTRate)
            ) {
                setGstError('CGST and SGST rates must be equal');
            } else {
                setGstError('');
            }
        }
    };

    const submitData = async () => {

        setIsLoading(true);

        try {
            // Fetch existing data
            const existingItems = await fetchData('CategoryApi', `/${companyId}`, token);
            console.log('Existing Items:', existingItems);

            if (
                existingItems.response_data &&
                Array.isArray(existingItems.response_data) &&
                existingItems.response_data.some(
                    (item) => item.Name === formData.Name
                )
            ) {
                setErrorMessage('Item with the same Name already exists.');
                setIsLoading(false);
                return;
            }

            if (
                existingItems.response_data &&
                Array.isArray(existingItems.response_data) &&
                existingItems.response_data.some(
                    (item) => item.Code === formData.Code
                )
            ) {
                setErrorMessage('Item with the same Code already exists.');
                setIsLoading(false);
                return;
            }
            if (parseFloat(formData.CGSTRate) !== parseFloat(formData.SGSTRate)) {
                alert('CGST and SGST rates must be equal');
                return;
            }
            // Validate form data
            if (!formData.Name) {
                setErrorMessage('Name is required.');
                setIsLoading(false);
                return;
            }

            if (!formData.Code) {
                setErrorMessage('Code is required.');
                setIsLoading(false);
                return;
            }

            if (!formData.CGSTRate) {
                setErrorMessage('CGST Rate is required.');
                setIsLoading(false);
                return;
            }

            if (!formData.SGSTRate) {
                setErrorMessage('SGST Rate is required.');
                setIsLoading(false);
                return;
            }

            if (!formData.HSNCode) {
                setErrorMessage('HSN Code is required.');
                setIsLoading(false);
                return;
            }

            if (!selectedCategoryType || typeof selectedCategoryType !== 'object' || !selectedCategoryType.value) {
                setErrorMessage('Please select a category.');
                setIsLoading(false);
                return;
            }
            if (!selectedMEASURESType || typeof selectedMEASURESType !== 'object' || !selectedMEASURESType.value) {
                setErrorMessage('Please select a unit of measure.');
                setIsLoading(false);
                return;
            }
            // if (!selectedSupplier || typeof selectedSupplier !== 'object' || !selectedSupplier.value) {
            //     setErrorMessage('Please select a supplier.');
            //     setIsLoading(false);
            //     return;
            // }

            // Submit data

            setFormData(prevData => ({
                ...prevData,
                CreatedBy: userId,
                CompanyId: companyId,
                CategoryId: selectedCategoryType?.value,
                UnitofMeasureId: selectedMEASURESType?.value,
                SupplierId: selectedSupplier?.value,
            }));

            const response = await postData('ItemApi', formData, token);
            console.log('Data Created success:', response);

            history.push('/ItemIndex');
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred. Please try again.');
        }
    };

    const [CategoryTypeOptions, setCategoryTypeOptions] = useState([]);
    const [selectedCategoryType, setSelectedCategoryType] = useState("");

    const fetchCategoryType = async () => {
        try {

            const response = await fetchData('ItemApi', `/Category/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(category => ({
                    value: category.Id,
                    label: category.Name
                }));
                setCategoryTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleCategoryTypeChange = (selectedOption) => {
        setSelectedCategoryType(selectedOption);
        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            CompanyId: companyId,
            CategoryId: selectedOption.value,
        }));
    };

    useEffect(() => {
        fetchCategoryType();
    }, []);

    // UOM (UNIT OF MEASURES)

    const [MEASURESTypeOptions, setMEASURESTypeOptions] = useState([]);
    const [selectedMEASURESType, setSelectedMEASURESType] = useState("");

    const fetchMEASURESType = async () => {
        try {

            const response = await fetchData('ItemApi', `/uom/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(uom => ({
                    value: uom.Id,
                    label: uom.Unit
                }));
                setMEASURESTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleMEASURESTypeChange = (selectedOption) => {
        setSelectedMEASURESType(selectedOption);
        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            CompanyId: companyId,
            UnitofMeasureId: selectedOption.value,
        }));
    };

    useEffect(() => {
        fetchMEASURESType();
    }, []);

    // Supplier

    const [SupplierOptions, setSupplierOptions] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState("");

    const fetchSupplier = async () => {
        try {

            const response = await fetchData('ItemApi', `/supplier/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(uom => ({
                    value: uom.Id,
                    label: uom.Name
                }));
                setSupplierOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleSupplierChange = (selectedOption) => {
        setSelectedSupplier(selectedOption);
        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            CompanyId: companyId,
            SupplierId: selectedOption.value,
        }));
    };

    useEffect(() => {
        fetchSupplier();
    }, []);


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto" style={{ minWidth: '101%' }}>

                <div className='w-full mb-2 flex' style={{ marginTop: '-20px' }}>
                    <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Item Create</h6>
                    <Button
                        style={{
                            background: 'linear-gradient(to right,rgb(94, 179, 138),rgb(98, 150, 61))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                        }}
                        onClick={submitData}
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <span>Save</span>}
                    </Button>

                    <Button
                        component={Link}
                        to="/ItemIndex"
                        className="linkcolor"
                        style={{
                            background: 'linear-gradient(to right,rgb(162, 31, 31),rgb(223, 91, 70))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                        }}
                    >
                        Cancel
                    </Button>

                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                <div className="w-full flex flex-wrap">
                    <div className="w-full" style={{ padding: '7px', borderRadius: '10px' }}>
                        <div className="w-full mb-3 flex" >

                            <div className="w-2/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    Code<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Code}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Code"
                                    name='Code'
                                    maxLength={10}  // ✅ set maximum characters here
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' }}
                                />
                            </div>
                            <div className="w-2/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    Bar Code<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.BarCode}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="BarCode"
                                    name='BarCode'
                                    maxLength={20}  // ✅ set maximum characters here
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' }}
                                />
                            </div>

                            <div className="w-3/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    Name<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Name}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Name"
                                    name='Name'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' }}
                                />
                            </div>

                            <div className="w-3/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    Searchable Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.SearchableName}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Searchable Name"
                                    name='SearchableName'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' }}
                                />
                            </div>




                        </div>

                        <div className="w-full mb-3 flex" >

                            <div className="w-2/5 mr-2">

                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    Category<span className="text-red-500">*</span>
                                </label>

                                <Select
                                    value={selectedCategoryType}
                                    onChange={handleCategoryTypeChange}
                                    options={CategoryTypeOptions}
                                    placeholder="Category"
                                    isSearchable
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            height: '32px',         // Adjust height
                                            minHeight: '32px',      // Ensure it doesn't shrink below this
                                            fontSize: '14px',       // Adjust font size
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            fontSize: '14px',       // Adjust font size for input text
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            fontSize: '14px',       // Adjust font size for selected value
                                        }),
                                    }}
                                />
                            </div>
                            <div className="w-1/6 mr-2">

                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    UOM<span className="text-red-500">*</span>
                                </label>

                                <Select
                                    value={selectedMEASURESType}
                                    onChange={handleMEASURESTypeChange}
                                    options={MEASURESTypeOptions}
                                    placeholder="UOM"
                                    isSearchable
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            height: '32px',         // Adjust height
                                            minHeight: '32px',      // Ensure it doesn't shrink below this
                                            fontSize: '14px',       // Adjust font size
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            fontSize: '14px',       // Adjust font size for input text
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            fontSize: '14px',       // Adjust font size for selected value
                                        }),
                                    }}
                                />

                            </div>


                            <div className="w-2/5 mr-2">

                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    Supplier<span className="text-red-500">*</span>
                                </label>

                                <Select
                                    value={selectedSupplier}
                                    onChange={handleSupplierChange}
                                    options={SupplierOptions}
                                    placeholder="Supplier"
                                    isSearchable
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            height: '32px',         // Adjust height
                                            minHeight: '32px',      // Ensure it doesn't shrink below this
                                            fontSize: '14px',       // Adjust font size
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            fontSize: '14px',       // Adjust font size for input text
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            fontSize: '14px',       // Adjust font size for selected value
                                        }),
                                    }}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    HSN Code<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.HSNCode}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="HSN Code"
                                    name='HSNCode'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' }}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    CGST Rate
                                </label>

                                <select
                                    className="shadow border rounded w-full px-3 text-black-700 leading-tight focus:shadow-outline"
                                    name="CGSTRate"
                                    value={formData.CGSTRate || 0}
                                    onChange={handleChange}
                                    style={{
                                        height: '32px',       // Adjust height
                                        fontSize: '14px',     // Font size
                                        paddingLeft: '8px',   // Optional padding
                                    }}
                                >
                                    <option value={0}>0</option>
                                    <option value={1.5}>1.5</option>
                                    <option value={2.5}>2.5</option>
                                    <option value={6}>6</option>
                                    <option value={9}>9</option>
                                    <option value={14}>14</option>
                                </select>
                            </div>



                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    SGST Rate
                                </label>

                                <select
                                    className="shadow border rounded w-full px-3 text-black-700 leading-tight focus:shadow-outline"
                                    name="SGSTRate"
                                    value={formData.SGSTRate || 0}
                                    onChange={handleChange}
                                    style={{
                                        height: '32px',       // Adjust height
                                        fontSize: '14px',     // Font size
                                        paddingLeft: '8px',   // Optional padding
                                    }}
                                >
                                    <option value={0}>0</option>
                                    <option value={1.5}>1.5</option>
                                    <option value={2.5}>2.5</option>
                                    <option value={6}>6</option>
                                    <option value={9}>9</option>
                                    <option value={14}>14</option>
                                </select>
                            </div>




                        </div>
                        <div className="w-full mb-3 flex" >

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    Purchase Rate
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.PurchaseRate}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="Purchase Rate"
                                    name='PurchaseRate'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px', textAlign: 'right' }}
                                />
                            </div>
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    MRP
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.MRP}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="MRP"
                                    name='MRP'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' , textAlign: 'right' }}
                                />
                            </div>
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    Sale Rate
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.SaleRate}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="Sale Rate"
                                    name='SaleRate'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' , textAlign: 'right' }}
                                />
                            </div>
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    WholeSale Rate
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.WholeSaleRate}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder=" WholeSale Rate"
                                    name='WholeSaleRate'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' , textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    Opening Stock
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.OpeningStock}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="Opening Stock"
                                    name='OpeningStock'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' , textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    Re Order Level
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.ReOrderLevelQty}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="Re Order Level"
                                    name='ReOrderLevelQty'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' , textAlign: 'right' }}
                                />
                            </div>
                        </div>

                    </div>

                </div>


            </div >
        </Fragment >
    );
};

export default ItemCreate;

